<template>
  <font-awesome-icon
    icon="link"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faLink } from '@fortawesome/free-solid-svg-icons'

library.add(faLink)

export default {
  name: 'CoozzyLinkIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
    width: 1rem;
  }
</style>
